export var RecordAudioStopByEnum;
(function (RecordAudioStopByEnum) {
    RecordAudioStopByEnum[RecordAudioStopByEnum["MOVE_TO_CANCEL"] = 0] = "MOVE_TO_CANCEL";
    RecordAudioStopByEnum[RecordAudioStopByEnum["TOOLTIP_CANCEL"] = 1] = "TOOLTIP_CANCEL";
})(RecordAudioStopByEnum || (RecordAudioStopByEnum = {}));
